/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Delete Forever.
 * @export
 */
export const ICON_DELETE_FOREVER = (
  <svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <g id="delete_forever_24px">
      <path d="M14.79 3.28999L15.5 4H18C18.55 4 19 4.45 19 5C19 5.55 18.55 6 18 6H6C5.44995 6 5 5.55 5 5C5 4.45 5.44995 4 6 4H8.5L9.20996 3.28999C9.39001 3.11 9.65002 3 9.91003 3H14.09C14.35 3 14.61 3.11 14.79 3.28999ZM6 19C6 20.1 6.90002 21 8 21H16C17.1 21 18 20.1 18 19V9C18 7.89999 17.1 7 16 7H8C6.90002 7 6 7.89999 6 9V19ZM9.16992 11.17C9.55994 10.78 10.1899 10.78 10.58 11.17L12 12.59L13.4199 11.17C13.8099 10.78 14.4399 10.78 14.83 11.17C15.22 11.56 15.22 12.19 14.83 12.58L13.4099 14L14.83 15.42C15.22 15.81 15.22 16.44 14.83 16.83C14.4399 17.22 13.8099 17.22 13.4199 16.83L12 15.41L10.58 16.83C10.1899 17.22 9.55994 17.22 9.16992 16.83C8.98267 16.6432 8.87744 16.3895 8.87744 16.125C8.87744 15.8605 8.98267 15.6068 9.16992 15.42L10.59 14L9.16992 12.58C8.77991 12.2 8.77991 11.56 9.16992 11.17Z" />
    </g>
  </svg>
);
